import { ApiClient } from '@api/api-configuration';
import QUERY_KEYS from '@app/common/queryKeys';
import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { DiscriminatedNotificationType } from '../types/notifications';

export const useWidgetNotifications = (userId: number, enableQuery = true) => {
  const { data, isFetching, isLoading, dataUpdatedAt } = useQuery({
    queryKey: [QUERY_KEYS.NOTIFICATIONS_WIDGET, userId],
    enabled: enableQuery && Boolean(userId),
    refetchInterval: 10 * 60 * 1000, // 10 minutes
    // refetch on window focus
    refetchOnWindowFocus: true,
    queryFn: async () => {
      const res = await ApiClient.notificationsApi.notifications.listNotifications({
        user_id: userId,
        limit: 100,
      });

      return res.data.data as DiscriminatedNotificationType[];
    },
  });

  const lastFetchedTime = dataUpdatedAt ? dayjs(dataUpdatedAt).fromNow() : '—';

  return {
    // All the 100 at once no paging here
    notifications: data || [],
    lastFetchedTime,
    areNotificationsFetching: isFetching,
    areNotificationsLoading: isLoading,
  };
};

export default useWidgetNotifications;
